import { IEvent, OptionType } from '../../../../utils/types';
import { Autocomplete, Button, Icon, Title } from '../../../common';
import { COLOURS } from '../../../../utils/consts';
import { useEventRequests } from '../useEventRequests';
import { useEffect, useState } from 'react';
import { useTranslation } from '../../../../hooks/translations/TranslationProvider';

interface EventInvitationDialogProps {
    isOpen: boolean;
    eventDetails: IEvent;
    isOwner: boolean;
    onClose: () => void;
    refreshEventData: () => void;
}

const EventInvitationDialog = ({
    isOpen,
    eventDetails,
    onClose,
    refreshEventData,
}: EventInvitationDialogProps) => {
    const { t } = useTranslation();

    const {
        searchOptions,
        isLoading,
        error,
        fetchResults,
        resultsIsLoading,
        createInvitation,
    } = useEventRequests();

    const [userId, setUserId] = useState('');

    useEffect(() => {
        setUserId('');
    }, [isOpen]);

    async function createInvitationHandler() {
        try {
            await createInvitation(eventDetails.id, userId);
            refreshEventData();
            onClose();
        } catch (error: any) {
            console.log('ERROR', error);
        }
    }

    function onUserSelection(_: string, result: OptionType) {
        setUserId(result.id as string);
    }

    if (!isOpen) {
        return null;
    }

    return (
        <div className="dialog-overlay">
            <div className="dialog-container">
                <div className="dialog-header">
                    <Icon
                        name="bx-x"
                        color={COLOURS.gray}
                        size="30px"
                        cursor="pointer"
                        onClick={onClose}
                    />
                    <Title text={t('inviteUserDialog.title')}></Title>
                </div>
                <div className="dialog-body">
                    <Autocomplete
                        name="userId"
                        startSearch={fetchResults}
                        isLoading={resultsIsLoading}
                        formError={userId && error}
                        results={searchOptions.users}
                        handleOptionClick={onUserSelection}
                        placeholder={t('inviteUserDialog.inputPlaceholder')}
                        className="full-width"
                        isDisabled={isLoading}
                    />
                </div>
                <div className="dialog-footer">
                    <Button
                        type="button"
                        text={t('inviteUserDialog.confirmButton')}
                        variant="green"
                        onClick={createInvitationHandler}
                        size="md"
                        disabled={!userId || isLoading}
                    />
                </div>
            </div>
        </div>
    );
};

export default EventInvitationDialog;
